import { AxiosInstance } from "axios"

import { UserApi } from "@/lib/user-api"
import { SettingsProps } from "@/components/settings"

export async function fetchSettingsProps(
  axios: AxiosInstance
): Promise<Omit<SettingsProps, "initSection" | "initUser">> {
  const userApi = new UserApi(axios)

  const userProfile = await userApi.fetchUserProfile()

  return {
    userProfile,
  }
}
